const companyName = "JyotiTechnosoft"

const titles = {

    home: `Dashboard | ${companyName}`,
    about: `About Us | ${companyName}`, 
    groupChart: `Group Chart | ${companyName}`,
    stackedChart: `Stacked Chart | ${companyName}`,
    candleChart: `CandleStick Chart | ${companyName}`,
    mapChart: `Map Chart | ${companyName}`,
    pieChart: `Pie Chart | ${companyName}`,
    sunburstChart: `SunBurst Chart | ${companyName}`,
};

export default titles;